import { useFormikContext } from 'formik'

import MultiSelectFilter from 'components/MultiSelectFilter'
import ItemLabel from 'components/ModifierGroups/Form/Drawers/Modifiers/ItemLabel'

import { FUSE_OPTIONS } from 'utils/fuseSettings'
import { itemsCategoryFilterOptions } from 'resources'

const Modifiers = ({
  handleSaveAssignedItems,
  items,
  goBack,
  defaultSelectedItemsUuids,
  defaultSelectedUuid,
}) => {
  const { setFieldValue, validateField } = useFormikContext()

  const handleChangeCheckbox = (uuids) => {
    handleSaveAssignedItems(uuids)
  }

  const handleSave = () => {
    goBack()
    setFieldValue('items', defaultSelectedItemsUuids)
    setTimeout(() => {
      validateField('items')
    }, 0)

    // if we uncheck modifier which is currently selected Default Included Modifier
    // we need to remove this modifier from Default Included Modifier Select
    // and set Default Included Modifier to null
    if (!defaultSelectedItemsUuids.includes(defaultSelectedUuid)) {
      setFieldValue('defaultSelectedUuid', null)
    }
  }

  return (
    <MultiSelectFilter
      items={items}
      itemsUuids={defaultSelectedItemsUuids}
      handleSave={handleSave}
      handleChangeCheckbox={handleChangeCheckbox}
      label={(item) => (
        <ItemLabel
          item={item}
          handleChangeCheckbox={handleChangeCheckbox}
          selectedItemsUuids={defaultSelectedItemsUuids}
        />
      )}
      fuseSettings={FUSE_OPTIONS}
      doubleToggleButtonOptions={itemsCategoryFilterOptions}
      checkboxIndeterminateLabel="All Items"
    />
  )
}

export default Modifiers
